// extracted by mini-css-extract-plugin
export default {"top":"NotFound_top__3DndN","cta":"NotFound_cta__DGNwM"};